/* SAVA mobile menu: SHOP / GIFTS screens and the COLLECTIONS progress bar. */
(() => {
  if (customElements.get('sava-nav')) return;
  class SavaNav extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-sava-open]');
        if (!btn) return;
        e.preventDefault();
        this.show(btn.dataset.savaOpen);
      });
      const row = this.querySelector('[data-sava-row]');
      const bar = this.querySelector('[data-sava-progress]');
      if (row && bar) {
        const sync = () => {
          const ratio = row.clientWidth / Math.max(row.scrollWidth, 1);
          const max = Math.max(row.scrollWidth - row.clientWidth, 1);
          bar.style.width = `${Math.max(ratio, 0.1) * 100}%`;
          bar.style.transform = `translateX(${(row.scrollLeft / max) * ((1 / Math.max(ratio, 0.1)) - 1) * 100}%)`;
        };
        row.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        new ResizeObserver(sync).observe(row);
        sync();
      }
      // Back to the main screen whenever the drawer closes
      const details = this.closest('details');
      if (details) details.addEventListener('toggle', () => { if (!details.open) this.show('main', true); });
    }
    show(name, silent) {
      this.querySelectorAll('[data-sava-panel]').forEach((p) => {
        const on = p.dataset.savaPanel === name;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
      if (silent) return;
      const scroller = this.closest('.drawer__content');
      if (scroller) scroller.scrollTop = 0;
      window.dispatchEvent(new Event('resize')); // let the product-row swiper measure itself
    }
  }
  customElements.define('sava-nav', SavaNav);
})();
